import React from 'react';
import ReactECharts from 'echarts-for-react';


type AppProps = {
    // title: string;
    // company_name?: String;
    // client_code?: number | string | undefined;
    seriesData?: [] | undefined | any;
    xAxisData ?: any;
    legendName?: string | undefined;
    barColor ?: [] | any;
    height?: string;
    xAxisName?: string;
    yAxisName? : string;
}
const BarGraph = ({ 
    seriesData,
    xAxisData, 
    legendName,
    barColor,
    height,
    xAxisName,
    yAxisName
}: AppProps) =>{

    const customHeight = height;
    const  colorOption = ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc']
    
    const option = {
        // color: ['#5470c6', '#91cc75', // '#fac858', // '#ee6666', '#73c0de', //'#3ba272', //'#fc8452', //'#9a60b4', '#ea7ccc'],
        color: barColor || colorOption,
        // title: {
        //     text: "Main Title",
        //     left: 0,
        //     top: 0,
        //     textStyle: {
        //         fontSize: 16,
        //         fontWeight: 'bold' 
        //     },
        //     subtextStyle: {
        //         fontSize: 20
        //     }
        // },
        tooltip: {
            trigger: 'axis',
            // axisPointer: {
            //     type: 'shadow'
            // }
        },
        xAxis: [{
            type: 'category',
            data: xAxisData,
            // max: 'dataMax'
            name: xAxisName,
            nameLocation: "middle",
            nameTextStyle: {
            color: "rgba(196, 196, 196, 1)"
            },
            nameGap: 30
        }],
        yAxis: [{
            type: 'value',
            name: yAxisName,
            nameLocation: "middle",
            nameTextStyle: {
                color: "rgba(196, 196, 196, 1)"
            },
            nameGap: 70
        }],
        legend: {
            right: 0,
            bottom: 0,
            icon: "circle",
            textStyle: {
                color: "rgba(154, 154, 154, 1)"
            }
            
        },
        grid: {
            // top: '20px',
            left: '10%',
            // right: '10px',
            // containLabel: true,
            // show: true,
            // height: "65%"
            // containLabel: true,
            right: '2%'
           
        },
        series: [
            // {   
            //     name: seriesName || '',
            //     data: seriesData,
            //     type: 'line',
            //     symbol: 'triangle',
            //     symbolSize: 20,
            //     lineStyle: {
            //         color: '#5470C6',
            //         width: 4,
            //         type: 'dashed'
            //     },
            //     itemStyle: {
            //         borderWidth: 3,
            //         borderColor: '#EE6666',
            //         color: 'yellow'
            //     }
            // },
            
            {   
                name: legendName || '',
                data: seriesData,
                type: 'bar',
            }
        ]
        // series: seriesData || []
    };
    

    return (
        <ReactECharts option={option}  style={{ height:  customHeight ? customHeight : '350px', maxWidth: '100%' }}/>
    )
}

export default BarGraph